import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyModule } from '@ngx-formly/core'; // This includes the FormlyAttributes directive
import { RadioGroupV3Component } from '@gea/digital-ui-lib';
import { FormFieldsService } from '../app/services/form-fields.service';
import { typedOptionsToArray } from '../app/services/FormlyHelper';
import { TypedOptionEntry } from '../app/pages/products/product.model';

@Component({
  selector: 'formly-geaui-radioGroup-v3',
  imports: [ReactiveFormsModule, FormlyModule, RadioGroupV3Component],
  template: `
    <geaui-radio-group-v3
      [label]="props.label ?? ''"
      [disabled]="props['disabled'] ?? false"
      [options]="resolvedOptions"
      [formGroupInput]="formGroup"
      [formFieldName]="field.key?.toString() ?? ''"
      [formlyAttributes]="field"
      [flexDirection]="'row'"
      (valueChange)="updateField()">
    </geaui-radio-group-v3>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeaUiRadioGroupV3TypeComponent extends FieldType<FieldTypeConfig> {
  constructor(private readonly formlyService: FormFieldsService) {
    super();
  }

  get formGroup(): FormGroup {
    return this.form as FormGroup;
  }

  get resolvedOptions(): { name: string; value: unknown; disabled: boolean }[] {
    const typedOptions = this.props['typedOptions'] as Record<string, TypedOptionEntry> | null | undefined;
    return typedOptions ? typedOptionsToArray(typedOptions) : [];
  }

  updateField(): void {
    if (this.field.key) {
      const newVal = this.formGroup.get(this.field.key.toString())?.value;
      this.formlyService.trackField({ key: this.field.key.toString(), value: newVal });
    }
  }
}
